import React from 'react';
import { Link } from 'react-router-dom';
import darkicon from '../assets/FINALDARKLOGO.svg';
import { useAuth } from '../context/AuthContext';
export default function Footer({ session }) {
  const { isBusiness } = useAuth();
  return (
    <footer className={`${isBusiness ? "hidden" : "flex"}  w-full py-[40px] lg:px-[96px] px-[24px] bg-white border-t border-gray-100`}>
      <div className='flex flex-col w-full 2xl:max-w-[1300px]  2xl:mx-auto gap-[40px]'>
        
        {/* Brand Identity */}
        <div className='flex flex-row items-center gap-[15px]'>
          <img className='w-[25px] h-[25px] xl:w-[32px] xl:h-[32px]' src={darkicon} alt="Sitemanifest" />
          <span className='text-[#323232] text-[18px] xl:text-[24px] tracking-[4px] font-staat uppercase'>SITEMANIFEST</span>
        </div>

        {/* The Grid: 5 Columns */}
        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-[30px] w-full'>
          
          {/* Column 1: Company */}
          <div className='flex flex-col gap-[12px]'>
            <h3 className='text-[#323232] font-poppins text-[13px] lg:text-[16px] font-bold uppercase'>Company</h3>
            <Link to="/about-us" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>About us</Link>
            <Link to="/faqs" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>FAQs</Link>
            <Link to="/blogs" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Blogs</Link>
          </div>

          {/* Column 2: Account */}
          <div className='flex flex-col gap-[12px]'>
            <h3 className='text-[#323232] font-poppins text-[13px] lg:text-[16px] font-bold uppercase'>Account</h3>
            {!session ? (
              <>
                <Link to="/signin" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Log in</Link>
                <Link to="/signup" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Sign up</Link>
                <Link to="/business/signup" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Business Sign up</Link>
              </>
            ) : (
              <Link to="/settings" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Profile Settings</Link>
            )}
          </div>

          {/* Column 3: For Business (Strategically placed) */}
          <div className='flex flex-col gap-[12px]'>
            <h3 className='text-[#323232] font-poppins text-[13px] lg:text-[16px] font-bold uppercase'>Directory</h3>
            {/* ⚡️ THE KEY LINK: Shows value to business owners */}
            <Link to="/business" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>For Business</Link>
            <Link to="/pricing" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Plans & Pricing</Link>
          </div>

          {/* Column 4: Legal */}
          <div className='flex flex-col gap-[12px]'>
            <h3 className='text-[#323232] font-poppins text-[13px] lg:text-[16px] font-bold uppercase'>Legal</h3>
            <Link to="/terms" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Terms</Link>
            <Link to="/Privacy" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Privacy Policy</Link>
            <Link to="/refund-policy" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px]'>Refund & Cancellation</Link>
          </div>

          {/* Column 5: Support */}
          <div className='flex flex-col gap-[12px]'>
            <h3 className='text-[#323232] font-poppins text-[13px] lg:text-[16px] font-bold uppercase'>Support</h3>
            <a href="mailto:support@sitemanifest.com" className='text-[#666] hover:text-black font-poppins text-[11px] lg:text-[14px] break-all'>support@sitemanifest.com</a>
            <p className='text-[#999] font-poppins text-[11px] lg:text-[14px] leading-relaxed'>
              Tbilisi, Georgia <br /> 
              Identity-First Protocol
            </p>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className='pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4'>
          <span className='text-[#999] text-[10px] lg:text-[12px] font-poppins'>
            © {new Date().getFullYear()} SITEMANIFEST. All Rights Reserved.
          </span>
          {/* ⚡️ THE BOT LINK: Secondary access point for search crawlers */}
          <Link to="/registry" className='text-[#999] hover:text-black text-[10px] lg:text-[12px] font-poppins uppercase tracking-widest'>
            Verified Registry Index
          </Link>
        </div>

      </div>
    </footer>
  );
}